import i18next from 'i18next';
import React from 'react';

import { Form } from '../../containers/Form/Form';
import {
  SparkasseAssignmentForm,
  SparkasseAssignmentFormProps,
} from '../SparkasseAssignmentForm/SparkasseAssignmentForm';

// eslint-disable-next-line import/no-named-as-default-member
const t = i18next.getFixedT.bind(i18next)(null, 'forms', 'defaultSparkasseAssignmentForm');

export const DefaultSparkasseAssignmentForm: React.FC<SparkasseAssignmentFormProps> = ({
  headline = t('headline'),
  subline = t('subline'),
  ...props
}) => {
  return (
    <Form initialValues={{ locationName: '' }}>
      <SparkasseAssignmentForm headline={headline} subline={subline} {...props} />
    </Form>
  );
};
